__turbopack_context__.v({
  "bottomPositioning": "Modal-module-scss-module__SiGmGq__bottomPositioning",
  "circleCloseButton": "Modal-module-scss-module__SiGmGq__circleCloseButton",
  "closeBtn": "Modal-module-scss-module__SiGmGq__closeBtn",
  "container": "Modal-module-scss-module__SiGmGq__container",
  "fitContent": "Modal-module-scss-module__SiGmGq__fitContent",
  "heading": "Modal-module-scss-module__SiGmGq__heading",
  "icon": "Modal-module-scss-module__SiGmGq__icon",
  "landscape": "Modal-module-scss-module__SiGmGq__landscape",
  "noPadding": "Modal-module-scss-module__SiGmGq__noPadding",
  "overlay": "Modal-module-scss-module__SiGmGq__overlay",
  "screenReader": "Modal-module-scss-module__SiGmGq__screenReader",
  "scrollable": "Modal-module-scss-module__SiGmGq__scrollable",
  "square": "Modal-module-scss-module__SiGmGq__square",
});
